import $ from 'jquery'

const pickupNews = {
  init() {
    const $container = $('.js-pickup-news')
    if (!$container.length) return

    const $slides = $container.find('.p-top-mv__pickup-slide')
    const $dots = $container.find('.js-pickup-dots .p-top-mv__pickup-dot')
    const $prev = $container.find('.js-pickup-prev')
    const $next = $container.find('.js-pickup-next')
    let current = 0
    const total = $slides.length

    function goTo(index) {
      if (index < 0) index = total - 1
      if (index >= total) index = 0
      current = index
      $slides.removeClass('is-active').eq(current).addClass('is-active')
      $dots.removeClass('is-active').eq(current).addClass('is-active')
    }

    $prev.on('click', function () {
      goTo(current - 1)
    })

    $next.on('click', function () {
      goTo(current + 1)
    })

    $dots.on('click', function () {
      goTo($(this).index())
    })

    function adjustSlideContents() {
      if (window.innerWidth > 767) return
      var pickupHeight = $container.outerHeight()
      var bottom = pickupHeight + 30
      $('.p-top-mv__slide-contents').css('bottom', bottom + 'px')
    }

    adjustSlideContents()
    $(window).on('resize', adjustSlideContents)
  },
}

export default pickupNews
